import baseTheme from '../baseTheme';
export var MuiFormHelperText = {
    root: {
        fontSize: baseTheme.typography.pxToRem(14),
        fontStyle: 'italic',
    },
    contained: {
        marginLeft: 0,
    },
};
//# sourceMappingURL=MuiFormHelperText.js.map